/** localStorage key for Entra ID token (JWT) used as Bearer on API calls. */
export const ENTRA_TOKEN_KEY = 'entraIdToken';

/** sessionStorage: last MSAL redirect / login error JSON for Login page to display. */
export const ENTRA_LOGIN_ERROR_KEY = 'bagent_entra_login_error';

/**
 * localStorage: Teams `authentication.authenticate()` child-window flow; iframe + popup share
 * the same origin, so the tab sets this before opening the popup, and the popup reads it.
 */
export const TEAMS_INTERACTIVE_AUTH_KEY = 'bagent_teams_interactive_auth';

/** Mock / local-dev auth (when Entra is not configured). */
export const LOCAL_USER_KEY = 'bagent_local_user';
export const LOCAL_ROLE_TOKEN_KEY = 'bagent_local_role_token';

/** @deprecated migrated from demoUser / demoToken */
export const LEGACY_DEMO_USER_KEY = 'demoUser';
export const LEGACY_DEMO_TOKEN_KEY = 'demoToken';

/** JWT from password sign-in. Separate from the Entra token: they are different
 * identity sources with different lifetimes, and one being present must never be mistaken
 * for the other. */
export const LOCAL_SESSION_TOKEN_KEY = 'bagent_local_session';

/**
 * Roles that reach the admin page for NUMBERS only - never for settings that change the app
 * for everyone, and never for user management.
 *
 *   Stats Admin - cost visibility across the whole product
 *   Firm Admin  - the head of a law firm: their own firm's people, and no one else's
 *
 * One list, imported by the route guard, the sidebar and the panel. Three separate checks is
 * how a role ends up able to open a page that then refuses to render, or worse, a page it
 * should never have reached. The SERVER is the enforcement point either way (routes/usage.js
 * scopes by the verified firmId); this only decides what the UI offers.
 */
export const USAGE_ONLY_ROLES = ['Stats Admin', 'Firm Admin'];

/** Everyone who may open the admin page at all. */
export const ADMIN_PAGE_ROLES = ['Admin', ...USAGE_ONLY_ROLES];

/**
 * localStorage: the address to prefill on the sign-in form.
 *
 * The ADDRESS only - never the password, and never a credential of any kind. This exists so
 * that being signed out by the idle timer costs a password instead of a password plus
 * retyping your own email.
 */
export const REMEMBERED_EMAIL_KEY = 'bagent_remembered_email';
